export default __webpack_public_path__ + "static/media/accstashLogo.b16975b9.svg";